import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { Checkbox, Stack } from '@lyearn/ui';
import * as LearningContent from '@/modules/corporate/components/LearningContent';
import { ILearningContent } from '@/modules/corporate/components/LearningContent/types';

import ContentDetail from '../ContentDetail';
import { disabledCheckbox } from './style';

function ContentSelector({
  content,
  isAlreadySelected,
  isSelected,
  multiSelect,
  onClick,
}: {
  content: ILearningContent;
  isAlreadySelected: boolean;
  isSelected: boolean;
  multiSelect: boolean;
  onClick?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Stack className="w-full flex-1 flex-shrink-0 overflow-hidden border-b border-solid border-border">
      <LearningContent.Provider
        className="flex w-full flex-shrink-0 cursor-pointer items-center justify-between py-16 ps-16 pe-20"
        content={content} // flex-shrink-0: safari fix - ui collapsing in some safari versions
        onClick={isAlreadySelected ? undefined : () => onClick?.()}>
        <ContentDetail content={content} />
        {multiSelect ? (
          <Checkbox
            checked={!!(isSelected || isAlreadySelected)}
            className={isAlreadySelected ? disabledCheckbox : ''}
            data-attr="SELECT"
            data-id={content.id}
            disabled={isAlreadySelected}
          />
        ) : null}
        {!multiSelect && isSelected ? <CheckMark className="h-24 w-24" /> : null}
      </LearningContent.Provider>
    </Stack>
  );
}

export default ContentSelector;
